<template>
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 logo-document-container">
    <div v-if="$browserDetect.isChrome" class="company-logo">
      <img :src="logoUrl" alt="Sichern" />
    </div>
    <div v-else class="company-logo-noChrome">
      <img :src="logoUrl" alt="Sichern" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoUrl: `${process.env.VUE_APP_BASE || '/s/'}assets/images/logo-sichern-white.png`
    }
  }
}
</script>

<style lang="scss" scoped>
@import './login.scss';
</style>
